import React from 'react'
import FilterButton from './FilterButton';
import OptionButton from './OptionButton';


export default function SearchPanelFilterNanto(props) {
    const anchorRef = React.useRef(null);
    
    function getDisabled(type){
        //未選択
        if(props.filters.type.length === 0){
            return false;
        }else{
            
            var isPhoto = props.filters.type.includes("photo");
            var isReport = props.filters.type.includes("report");
            var isTrafficRegulation = props.filters.type.includes("trafficregulation");
            var isOther = props.filters.type.some((item) => item !== "photo" && item !== "report" && item !== "trafficregulation")

            //撮影日時
            if(type === "filmingDateTime"){
                return !isPhoto;
            }else
            //住民通報
            if(type === "report"){
                return !isReport;
            }else
            //通行制限
            if(type === "trafficregulation"){
                return !isTrafficRegulation;
            }else
            //その他
            {
                return !isOther;
            }
        }
    }

    return (
        <div className={"searchpanel-collapsed " + (props.searchPanelVisible ? "searchpanel-visible" : "")}>
                        
            <div ref={anchorRef} className="searchpopupshow" />

            <div className="searchfilters">
                <FilterButton label="対象"
                    userAuthorities={props.userAuthorities}
                    keyword={props.keyword}
                    filters={props.filters}
                    width={props.width}
                    height={props.height}
                    anchorRef={anchorRef}
                    updateShowFiltersInfo={props.updateShowFiltersInfo}
                    viewtype={props.viewtype}
                    isMobileMode={props.isMobileMode}
                    onApplyFilter={props.onApplyFilter}
                    onClick={props.onSearchFilterClick}
                    
                    isDisabled={false}
                    isShow={true}

                    isFacilityType={true}
                    popupKind={'list'}
                    filterKind={'type'}
                    targetTypes={props.filters.type}
                />

                <FilterButton label={"管理事務所"}
                    userAuthorities={props.userAuthorities}
                    keyword={props.keyword}
                    filters={props.filters}
                    width={props.width}
                    height={props.height}
                    anchorRef={anchorRef}
                    updateShowFiltersInfo={props.updateShowFiltersInfo}
                    viewtype={props.viewtype}
                    isMobileMode={props.isMobileMode}
                    onApplyFilter={props.onApplyFilter}
                    onClick={props.onSearchFilterClick}

                    isDisabled={getDisabled("componentManagerOffice")}
                    isShow={!getDisabled("componentManagerOffice") || props.filters.componentManagerOffice.length !== 0}

                    popupKind={'list'}
                    filterKind={'componentManagerOffice'}
                    targetTypes={props.filters.componentManagerOffice}
            />

                <FilterButton label="健全度"
                    userAuthorities={props.userAuthorities}
                    keyword={props.keyword}
                    filters={props.filters}
                    width={props.width}
                    height={props.height}
                    anchorRef={anchorRef}
                    updateShowFiltersInfo={props.updateShowFiltersInfo}
                    viewtype={props.viewtype}
                    isMobileMode={props.isMobileMode}
                    onApplyFilter={props.onApplyFilter}
                    onClick={props.onSearchFilterClick}
                    
                    isDisabled={getDisabled("overallHealthLevel")}
                    isShow={!getDisabled("overallHealthLevel") || props.filters.overallHealthLevel.length !== 0}

                    popupKind={'list'}
                    filterKind={'overallHealthLevel'}
                    targetTypes={props.filters.overallHealthLevel}
                />
                
                <FilterButton label="写真撮影日"
                    userAuthorities={props.userAuthorities}
                    keyword={props.keyword}
                    filters={props.filters}
                    width={props.width}
                    height={props.height}
                    anchorRef={anchorRef}
                    viewtype={props.viewtype}
                    isMobileMode={props.isMobileMode}
                    updateShowFiltersInfo={props.updateShowFiltersInfo}
                    onApplyFilter_date={props.onApplyFilter_date}
                    onClick={props.onSearchFilterClick}

                    isDisabled={getDisabled("filmingDateTime")}
                    isShow={!getDisabled("filmingDateTime") || props.filters.filmingDateTime_str.length !== 0 || props.filters.filmingDateTime_end.length !== 0}

                    popupKind={'date'}
                    filterKind={'filmingDateTime'}
                    filterKind_str={"filmingDateTime_str"}
                    filterKind_end={"filmingDateTime_end"}
                    DateTime_str={props.filters.filmingDateTime_str}
                    DateTime_end={props.filters.filmingDateTime_end}
                />
                
                <FilterButton label="住民通報"
                    userAuthorities={props.userAuthorities}
                    keyword={props.keyword}
                    filters={props.filters}
                    width={props.width}
                    height={props.height}
                    anchorRef={anchorRef}
                    viewtype={props.viewtype}
                    isMobileMode={props.isMobileMode}
                    updateShowFiltersInfo={props.updateShowFiltersInfo}
                    onClick={props.onSearchFilterClick}
                    onApplyFilter_date={props.onApplyFilter_date}
                    onApplyFilter_noSearch = {props.onApplyFilter_noSearch}
                    onSearch={props.onSearch}
                    
                    isDisabled={getDisabled("report")}
                    isShow={!getDisabled("report")}

                    filterKind={'report'}
                    />

                <FilterButton label="通行制限"
                    userAuthorities={props.userAuthorities}
                    keyword={props.keyword}
                    filters={props.filters}
                    width={props.width}
                    height={props.height}
                    anchorRef={anchorRef}
                    viewtype={props.viewtype}
                    isMobileMode={props.isMobileMode}
                    updateShowFiltersInfo={props.updateShowFiltersInfo}
                    onClick={props.onSearchFilterClick}
                    onApplyFilter_date={props.onApplyFilter_date}
                    onApplyFilter_noSearch = {props.onApplyFilter_noSearch}
                    onSearch={props.onSearch}
                    
                    isDisabled={getDisabled("trafficregulation")}
                    isShow={!getDisabled("trafficregulation")}

                    filterKind={'trafficregulation'}
                    />

                <OptionButton label="オプション" onClick={props.onSearchOptionClick} />
            </div>
        </div>
    );

}
